import React, { useState, Fragment, useContext, useEffect } from 'react' // useEffect, useContext
import PropTypes from 'prop-types'
// import { Link } from "react-router-dom";
import Recaptcha from 'react-recaptcha'
// import Gdpr from './gdprform' import { GlobalContext } from
// "../../lib-atomic-context";
/* packages */
import { Redirect } from 'react-router'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { GlobalContext } from '../../lib-atomic-context'
import MaskedInput from 'react-text-mask'

import MuiExpansionPanel from '@material-ui/core/ExpansionPanel'
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Spinner2 from '../../app-module-cms-section-page-spinner/default'
//dialogBox
import DialogBox from '../../lib-atomic/dialog/dialogbox'
// import Input from "@material-ui/core/Input";
import { Inputs, Buttons, Invalid } from '../../lib-atomic'
import { FormHook, LocalStorage, WindowSize } from '../../lib-atomic-functions' // LocalStorage

import {
  ModuleWrapperXl,
  ModuleSubTitle,
  ModSubWrapp,
  ModXlWrapp,
  ModLongWrapp,
  ModLongFillWrapp,
  ModTitleText,
  ModContentText,
  ModFormLabelText,
} from '../../lib-atomic-design-section'
import { FetchContextApiV2 } from '../../lib-atomic-functions'
import CONFIG from '../config'

/* CONSTANTS */
const LOGINOBJECTS = CONFIG.application.account.objects
//const { token } = LocalStorage.getLS().login
const ENDPOINTS = CONFIG.application.account.api.endpoints
const LOGINOBJECTSCONFIG = {
  url: ENDPOINTS.auth.url,
  method: ENDPOINTS.auth.method,
  headers: ENDPOINTS.auth.headers,
  responseType: 'json',
}
const UPDATE = {
  url: ENDPOINTS.register.url,
  method: ENDPOINTS.register.method,
  headers: ENDPOINTS.register.headers,
  responseType: 'json',
}
// const LOGINFAILRESPONSE = CONFIG.application.account.responses.fail
const UNVERIFIEDRESPONSE = CONFIG.application.account.responses.unverified

/* CONSTANTS */

// Styles
const useStyles = makeStyles((theme) => ({
  column: {
    flexBasis: '50%',
  },
  column2: {
    flexBasis: '100%',
  },
  img: {
    maxWidth: '100%',
    height: 'auto',
  },
  paper: {
    // padding: theme.spacing(3),
    color: 'black',
    marginBottom: '50px',
  },
  inline: {
    display: 'flex',
  },
  text: {
    marginTop: '10px',
    marginBottom: '10px',
  },
}))

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel)

const ExpansionPanelSummary = withStyles({
  root: {
    minHeight: 56,
    paddingLeft: '0px',
    paddingRight: '0px',

    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary)

const ExpansionPanelDetails = withStyles((theme) => ({
  root: {
    padding: '0',
  },
}))(MuiExpansionPanelDetails)

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#008938',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#008938',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        margin: classes.margin,
      }}
      {...props}
    />
  )
})

function TextMaskCustom(props) {
  const { inputRef, ...other } = props

  return (
    <MaskedInput
      className="dob-input"
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholder="DD/MM/YYYY" // showMask
    />
  )
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
}
const login = (props, match, history) => {
  const { width, height } = WindowSize()
  const { country, lang } = LocalStorage.getLS()
  const mainCurrentlanguage = LocalStorage.getLS().translation.json
  const { token } = LocalStorage.getLS().login
  const currentlanguage = LocalStorage.getLS().translation.json.registrationpage

  const { update } = useContext(GlobalContext)
  const { firstName, lastName, email } = props

  LOGINOBJECTS.firstName.initial = firstName
  LOGINOBJECTS.lastName.initial = lastName
  LOGINOBJECTS.email.initial = email

  /* state */
  const [response, setresponse] = React.useState()
  const [data, setdata] = React.useState()
  const [open, setOpen] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [isNext, seisNext] = useState(1)
  // const [verified,     setVerified] = useState(false)
  const [visiblePW, setVisiblePW] = useState(false)
  const [visiblePWC, setVisiblePWC] = useState(false) // setVisiblePWC
  const [isSms, setisSms] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const [spin, setSpin] = useState(false)
  const [redirect, setredirect] = useState(false)
  const [isdialog, setisdialog] = useState(false)
  const [disable, isDisable] = useState(false)
  //Email,promocode,accesscode validation API//

  const [updateData] = FetchContextApiV2(UPDATE)
  const updateExecute = async ({ body, newHeader }) => {
    update.dispatch({
      type: update.actionTypes.FETCH_UPDATE,
      update: await updateData(
        {
          body,
          newHeader,
        },
        update
      ),
    })
  }
  const profileResetExecute = () => {
    update.dispatch({
      type: update.actionTypes.RESET,
    })
  }

  useEffect(() => {
    if (update.state.data) {
      setSpin(false)
      setisdialog(false)
      setOpen(false)
      const { updateObject } = update.state.data

      if (updateObject.response) {
        setisdialog(false)
        var message = {
          outComeCode: '1',
          title: '',
          outComeMessage: updateObject.response.data,
        }
        setresponse(message)
        setOpen(false)
      } else {
        setSpin(false)
        setOpen(true)
        setisdialog(true)
        var message = {
          outComeCode: '0',
          title: '',
          outComeMessage: currentlanguage.page_success_response,
        }
        setresponse(message)
        // setresponse("Your details have been successfully updated")
        console.log('open1', open)
        profileResetExecute()
        // props.history.push('/nz/en/home')
      }
      // if (registerObject.response.data.outComeCode != 0) {
      // console.log("outComeCode",registerObject.response.data.outComeCode);
      // console.log("outComeMessage",registerObject.response.data.outComeMessage);
      // console.log("outComeUserMessage",registerObject.response.data.outComeUserMess
      // a ge); setresponse(registerObject.response.data); setOpen(true); }
    }
  }, [update.state])

  // specifying verify callback function

  const handleSubmit = async () => {
    setSpin(true)

    var body = {
      // email: props.email,
      firstName: values.firstName,
      lastName: values.lastName,
    }
    var newHeader = {
      Authorization: token,
    }
    await updateExecute({ body, newHeader })
  }

  const { values, onChange, onSubmit, error } = FormHook.useFormHook(
    handleSubmit,
    LOGINOBJECTS
  )

  console.log('erororrororor', error)

  const userfirstName = {
    ...LOGINOBJECTS.firstName,
    error: error.firstName,
    value: values.firstName,
    onChange,
    translation: mainCurrentlanguage,
  }
  const userlastName = {
    ...LOGINOBJECTS.lastName,
    error: error.lastName,
    value: values.lastName,
    onChange,
    translation: mainCurrentlanguage,
  }

  const useremailAddress = {
    ...LOGINOBJECTS.email,

    value: values.email,
    onChange,
    translation: mainCurrentlanguage,
  }
  const emailConfirm = {
    ...LOGINOBJECTS.emailconfirm,

    value: values.emailconfirm,
    onChange,
    translation: mainCurrentlanguage,
  }

  const handleClose = (value) => {
    setisdialog(false)
    // setresponse(false)
  }

  const handleChange = (event) => {
    setisSms(!isSms)
  }

  const handleChange2 = (event) => {
    setExpanded(!expanded)
    setisSms(!isSms)
  }
  const classes = useStyles()
  const submitButton = {
    fullWidth: true,
  }

  const resetButton = {
    fullWidth: true,
    onClick: () => {
      props.props.history.push('/forgot_password')
    },
  }
  // const failLogin = { error: [LOGINFAILRESPONSE] }
  const verifyLogin = {
    error: [UNVERIFIEDRESPONSE],
  }
  // console.log("Window", window.screen.width);

  return (
    <form onSubmit={onSubmit} noValidate>
      {spin && <Spinner2.Popup />}
      {isdialog && (
        <DialogBox
          selectedValue={response}
          open={isdialog}
          onClose={handleClose}
        />
      )}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} spacing={3}>
          <Typography variant="h5" className={classes.paper}>
            <p style={{ fontFamily: 'SubwayFootlong', margin: 0 }}>
              {currentlanguage.page_reg_details}
            </p>
          </Typography>

          <div
            style={{
              display: 'flex',
            }}
          >
            <div
              style={{
                display: 'inline-block',
                float: 'left',
                width: '100%',
              }}
            >
              <Typography variant="body2" className={classes.text}>
                <p style={{ fontFamily: 'SubwayFootlong', margin: 0 }}>
                  {currentlanguage.page_reg_firstname}
                </p>
                <Inputs.Text {...userfirstName} />
              </Typography>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
            }}
          >
            <div
              style={{
                display: 'inline-block',
                float: 'left',
                width: '100%',
              }}
            >
              <Typography variant="body2" className={classes.text}>
                <p style={{ fontFamily: 'SubwayFootlong', margin: 0 }}>
                  {currentlanguage.page_reg_lastname}
                </p>
                <Inputs.Text {...userlastName} />
              </Typography>
            </div>
          </div>
        </Grid>
        {/* <br/> */}
        <Grid item xs={12} sm={6} spacing={3}>
          <Typography variant="h5" className={classes.paper}>
            <p style={{ fontFamily: 'SubwayFootlong', margin: 0 }}>
              {currentlanguage.page_reg_title_1}
            </p>
          </Typography>

          <div
            style={{
              display: 'flex',
            }}
          >
            <div
              style={{
                display: 'inline-block',
                float: 'left',
                width: '100%',
              }}
            >
              <Typography variant="body2" className={classes.text}>
                <p style={{ fontFamily: 'SubwayFootlong', margin: 0 }}>
                  {currentlanguage.page_reg_email}
                </p>
                <Inputs.Text {...useremailAddress} disabled />
              </Typography>
            </div>
          </div>
        </Grid>
        {/* </Grid> */}
        <br />
      </Grid>

      <Grid
        container
        item
        xs={12}
        sm={10}
        spacing={3}
        style={{ marginLeft: 0, marginRight: 0, paddingLeft: 0 }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          style={{ paddingLeft: width > 600 ? 0 : null }}
        >
          <div>
            <Buttons.Normal {...submitButton}>
              {currentlanguage.page_reg_save_button}
            </Buttons.Normal>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          style={{ paddingLeft: width > 600 ? 0 : null }}
        >
          <div>
            <Buttons.Normal {...resetButton}>
              {currentlanguage.page_reg_password_reset}
            </Buttons.Normal>
          </div>
        </Grid>
      </Grid>
    </form>
  )
}

export default login
